var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class PoseAnswer {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get pose() {
        return this.parent;
    }
    get app() {
        return this.pose.app;
    }
    get currentlyPosedAnswer() {
        if (!this.app.stage.itemOnStage)
            return undefined;
        if (this.app.stage.itemOnStage.type !== 'answer')
            return undefined;
        const answer = this.app.stage.itemOnStage;
        if (answer.finishDate)
            return undefined;
        return answer;
    }
    get currentlyPosedAsArray() {
        if (this.currentlyPosedAnswer) {
            return [this.currentlyPosedAnswer];
        }
        return [];
    }
    get posedAnswerNotCompleted() {
        if (!this.currentlyPosedAnswer)
            return undefined;
        if (this.currentlyPosedAnswer.completeDate)
            return undefined;
        return this.currentlyPosedAnswer;
    }
}
__decorate([
    computed
], PoseAnswer.prototype, "currentlyPosedAnswer", null);
__decorate([
    computed
], PoseAnswer.prototype, "posedAnswerNotCompleted", null);
